import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../infra/base-service';
import { ChaveValor } from '../interfaces/segmentacao/chave-valor.interface';
import { TipoFiltro } from '../enums/tipo-filtro.enum';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from '../interfaces/api-response.interface';
import { Novidade, ResponseNovidade } from '../interfaces/novidade/novidade.interface';
import { Notificacao, ResponseNotificacao } from '../interfaces/notificacao/notificacao.interface';
import { FiltroSegmentacao } from '../interfaces/segmentacao/filtro-segmentacao.interface';
import { ResponseOportunidades } from '../interfaces/segmentacao/response-oportunidades.interface';
  @Injectable({
  providedIn: 'root'
})

export class HomeService extends BaseService {

  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
  }

  listarFiltroAbrangencia(): Promise<ChaveValor[]> {
    const params = {
      tipo: TipoFiltro.Abrangencia
    };
    return this.get<ChaveValor[]>('dados/listar-filtro', params);
  }

  async listarNovidades(quantidade: number, pagina: number): Promise<ResponseNovidade> {
    return this.get<ResponseNovidade>(`dashboard/listar?quantidade=${quantidade}&pagina=${pagina}`);
  }

  async marcarComoLida(id: number): Promise<boolean> {
    return this.post<boolean>('dashboard/marcarcomolidanotificacao', [id]);
  }

  async buscarOportunidades(abrangencia: string[], termoPesquisa: string): Promise<ResponseOportunidades> {
    const abrangenciaParams = abrangencia
        .map(item => `abrangencia=${encodeURIComponent(item)}`)
        .join('&');
    
    let queryString = '';
    
    if (abrangenciaParams) {
        queryString += abrangenciaParams;
    }
    
    if (termoPesquisa) {
        queryString += queryString ? '&' : '';
        queryString += `pesquisa=${encodeURIComponent(termoPesquisa)}`;
    }

    const url = queryString ? `dashboard/oportunidades?${queryString}` : 'dashboard/oportunidades';
    
    return this.get<ResponseOportunidades>(url);
  }

  async BuscarNotificacoes(): Promise<ResponseNotificacao> {
    return this.get<ResponseNotificacao>('dashboard/notificacoes');
  }
}